'use strict'

// A page with openAsModal opens in a dialog when another page links to it.
// Visiting that page's address still shows it as a full page.

function pageOpensAsModal (page) {

  if (!page) return false

  return page.openAsModal === true || page.openAsModal === 'true'
}

function normalizeAppPath (path) {

  const raw = String(path || '').split('?')[0].split('#')[0]

  if (raw.length > 1 && raw.endsWith('/')) return raw.replace(/\/+$/, '')

  return raw || '/'
}

function decodeSegment (segment) {

  try {

    return decodeURIComponent(segment)
  } catch (err) {

    return segment
  }
}

// Matches the live app's path rule: one segment is the page, and with two or
// more the page is the second-to-last segment. No segment means the home page.
const { parseLiveSegments } = require('./embed')

function pageTargetFromAppPath (path, application) {

  const normalized = normalizeAppPath(path)
  const segments = normalized.split('/').filter(Boolean).map(decodeSegment)

  if (!segments.length || !application || segments[0] !== application) return null

  const located = parseLiveSegments(segments.slice(1))

  if (!located.pageUniqueTitle) {

    return { home: true, pageUniqueTitle: null, accessKey: null, segments: located.segments }
  }

  return {
    home: false,
    pageUniqueTitle: located.pageUniqueTitle,
    accessKey: located.accessKey,
    segments: located.segments
  }
}

function modalNavigationTarget ({ path, application, modalUniqueTitles, homeUniqueTitle, currentPageUniqueTitle }) {

  const located = pageTargetFromAppPath(path, application)

  if (!located) return null

  const pageUniqueTitle = located.home ? (homeUniqueTitle || '') : located.pageUniqueTitle

  if (!pageUniqueTitle || pageUniqueTitle === currentPageUniqueTitle) return null

  const titles = modalUniqueTitles instanceof Set
    ? modalUniqueTitles
    : new Set(modalUniqueTitles || [])

  if (!titles.has(pageUniqueTitle)) return null

  return {
    pageUniqueTitle,
    accessKey: located.accessKey,
    segments: located.segments,
    path: normalizeAppPath(path)
  }
}

module.exports = {
  pageOpensAsModal,
  normalizeAppPath,
  pageTargetFromAppPath,
  modalNavigationTarget
}
